import type { ComponentTheme } from '../types/component-theme';
import { selectedCardShadowStyles } from '../shared-styles';

export default {
    slots: {
        root:
            'group relative flex cursor-pointer flex-col items-center gap-[0.35rem] rounded-[1.25rem] border px-3 ' +
            'py-4 text-center transition-[border-color,background] duration-250 ease-[ease]',
        outerShadow:
            'pointer-events-none absolute inset-0 rounded-[inherit] shadow-none transition-shadow duration-250',
        insetShadow:
            'pointer-events-none absolute inset-0 rounded-[inherit] shadow-(--pagination-button-active-shadow)',
        icon: 'mb-1 text-(--accent-solid)',
        label: 'block font-(family-name:--primary-font) text-[0.82rem] font-bold leading-[1.3]',
        description: 'block font-(family-name:--secondary-font) text-[0.68rem] leading-[1.4]'
    },
    variants: {
        selected: {
            true: {
                root:
                    'border-(--accent-solid) text-(--pure-white) bg-(image:--accent-gradient) ' +
                    'hover:bg-(image:--accent-gradient-hover)',
                outerShadow: selectedCardShadowStyles,
                insetShadow:
                    'shadow-[inset_0.25rem_0.25rem_0.625rem_rgba(15,23,42,0.35),inset_-0.25rem_-0.25rem_0.625rem_rgba(15,23,42,0.12)]',
                icon: 'text-(--pure-white)',
                label: 'text-(--pure-white)',
                description: 'text-(--glass-border-top)'
            },
            false: {
                root:
                    'border-(--slate-alpha-20) bg-[rgba(118,100,210,0.04)] hover:border-(--slate-alpha-30) ' +
                    'hover:bg-[rgba(118,100,210,0.08)]',
                outerShadow: 'group-hover:shadow-(--selectable-card-hover-shadow)',
                icon: 'text-(--accent-solid)',
                label: 'text-(--text-dark)',
                description: 'text-(--text-muted)'
            }
        },
        disabled: {
            true: {
                root: 'pointer-events-none opacity-55 saturate-50',
                outerShadow: 'shadow-none',
                icon: 'text-(--text-muted)',
                label: 'text-(--text-muted)',
                description: 'text-(--text-muted)'
            },
            false: {
                root: 'cursor-pointer'
            }
        }
    },
    compoundVariants: [
        {
            selected: true,
            disabled: true,
            class: {
                root: 'border-(--accent-solid) bg-(image:--accent-gradient) opacity-100 saturate-50',
                outerShadow: 'shadow-(--progress-glow-shadow-lg)',
                icon: 'text-(--pure-white)!',
                label: 'text-(--pure-white)!',
                description: 'text-(--glass-border-top)'
            }
        }
    ]
} satisfies ComponentTheme;
